// Prüfung der Prompt-Vorlage im Browser, spiegelt `template.problems` der API (die API prüft verbindlich).

const PLACEHOLDER = /\{\{\s*([a-zA-Z_]+)\s*\}\}/g;

export type TemplateVariable = { name: string; description: string; required: boolean };

/** Gründe, warum die Vorlage nicht gespeichert werden darf (leer = in Ordnung). */
export function templateProblems(body: string, variables: TemplateVariable[]): string[] {
  const found = new Set([...body.matchAll(PLACEHOLDER)].map((m) => m[1] ?? ""));
  const known = new Set(variables.map((v) => v.name));
  const issues: string[] = [];
  const missing = variables.filter((v) => v.required && !found.has(v.name));
  if (missing.length > 0) issues.push(`Pflichtvariable fehlt: ${missing.map((v) => `{{${v.name}}}`).join(", ")}`);
  const unknown = [...found].filter((name) => !known.has(name)).sort();
  if (unknown.length > 0) issues.push(`Unbekannte Variable: ${unknown.map((n) => `{{${n}}}`).join(", ")}`);
  return issues;
}

/** Fügt Text an der Cursorposition ein (oder am Ende) und liefert den neuen Text und die neue Cursorposition. */
export function insertAt(text: string, insert: string, start: number | null, end: number | null): [string, number] {
  if (start === null || end === null || start > text.length) {
    const spacer = text === "" || text.endsWith("\n") || text.endsWith(" ") ? "" : " ";
    return [`${text}${spacer}${insert}`, text.length + spacer.length + insert.length];
  }
  return [`${text.slice(0, start)}${insert}${text.slice(end)}`, start + insert.length];
}
